// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-containers-Profile-Suggestions-styles--banner--AIura {
  position: relative;
  box-sizing: border-box;
  border-radius: 1px;
  background-image: linear-gradient(249deg, #eef2f4, #e5eaee);
  margin: 15px 10px 9px;
  padding: 15px 20px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--banner--AIura {
    width: 595px;
    margin: 25px 25px 0;
    padding: 15px 50px;
}
  }

.src-containers-Profile-Suggestions-styles--banner--AIura h2 {
    margin: 0;
    padding-right: 15px;
    font-family: Roboto, sans-serif;
    color: #343b4c;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--banner--AIura h2 {
      padding-right: 0;
      font-size: 17px;
      line-height: 25px;
  }
    }

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--expanded--B8nZ7 {
    padding: 40px 50px 45px;
}
  }

.src-containers-Profile-Suggestions-styles--button--Nza5d {
  position: absolute;
  height: 20px;
  top: 15px;
  right: 15px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--button--Nza5d {
    height: 15px;
    top: 20px;
    right: 20px;
}
  }

.src-containers-Profile-Suggestions-styles--button--Nza5d .rui-Button-content {
    padding: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--button--Nza5d .rui-Button-content {
      width: 15px;
      height: 15px;
      line-height: 15px;
  }
    }

.src-containers-Profile-Suggestions-styles--item--xT8l8 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 15px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--item--xT8l8 {
    align-items: center;
}
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--item--xT8l8:first-of-type {
      margin-top: 25px;
  }
    }

.src-containers-Profile-Suggestions-styles--item--xT8l8 .src-containers-Profile-Suggestions-styles--dot--cXBcA {
    width: 5px;
    height: 5px;
    margin-top: 8px;
    border-radius: 50%;
    background-color: #343b4c;
  }

.src-containers-Profile-Suggestions-styles--item--xT8l8 p {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 20px;
    width: calc(100% - 5px - 10px);
    margin: 0 0 0 10px;
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-Suggestions-styles--item--xT8l8 p {
      width: 430px;
      margin: 0 0 0 20px;
  }
    }

.src-containers-Profile-Suggestions-styles--item--xT8l8 p a,.src-containers-Profile-Suggestions-styles--item--xT8l8 p span {
      cursor: pointer;
      color: #315efb;
    }

.src-containers-Profile-Suggestions-styles--item--xT8l8 p a:active {
        color: #6674a6;
      }

.src-containers-Profile-Suggestions-styles--item--xT8l8 p span:active {
        color: #6674a6;
      }

.src-containers-Profile-Suggestions-styles--item--xT8l8 p a:hover,.src-containers-Profile-Suggestions-styles--item--xT8l8 p span:hover,.src-containers-Profile-Suggestions-styles--item--xT8l8 p a:focus,.src-containers-Profile-Suggestions-styles--item--xT8l8 p span:focus {
        color: #6674a6;
      }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/Suggestions/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;AAuBpB;;AArBE;;AARF;IASI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AAkBtB;EAjBE;;AAEA;IACE,SAAS;IACT,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EAOnB;;AALE;;AATF;MAUI,gBAAgB;MAChB,eAAe;MACf,iBAAiB;EAErB;IADE;;AAKF;;AADF;IAEI,uBAAuB;AAE3B;EADE;;AAGF;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;AAoBb;;AAlBE;;AANF;IAOI,YAAY;IACZ,SAAS;IACT,WAAW;AAef;EAdE;;AAEA;IACE,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iBAAiB;EAOnB;;AALE;;AANF;MAOI,WAAW;MACX,YAAY;MACZ,iBAAiB;EAErB;IADE;;AAIJ;EACE,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AA4ClB;;AA1CE;;AANF;IAOI,mBAAmB;AAyCvB;EAxCE;;AAGE;;AADF;MAEI,gBAAgB;EAEpB;IADE;;AAGF;IACE,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;AAEA;IACE,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;EAkBpB;;AAhBE;;AAPF;MAQI,YAAY;MACZ,kBAAkB;EActB;IAbE;;AAEA;MAEE,eAAe;MACf,cAAc;IAOhB;;AALE;QAGE,cAAc;MAChB;;AAJA;QAGE,cAAc;MAChB;;AAJA;QAGE,cAAc;MAChB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.banner {\n  position: relative;\n  box-sizing: border-box;\n  border-radius: 1px;\n  background-image: linear-gradient(249deg, #eef2f4, #e5eaee);\n  margin: 15px 10px 9px;\n  padding: 15px 20px;\n\n  @media (--desktop) {\n    width: 595px;\n    margin: 25px 25px 0;\n    padding: 15px 50px;\n  }\n\n  & h2 {\n    margin: 0;\n    padding-right: 15px;\n    font-family: Roboto, sans-serif;\n    color: #343b4c;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n\n    @media (--desktop) {\n      padding-right: 0;\n      font-size: 17px;\n      line-height: 25px;\n    }\n  }\n}\n\n.expanded {\n  @media (--desktop) {\n    padding: 40px 50px 45px;\n  }\n}\n\n.button {\n  position: absolute;\n  height: 20px;\n  top: 15px;\n  right: 15px;\n\n  @media (--desktop) {\n    height: 15px;\n    top: 20px;\n    right: 20px;\n  }\n\n  & :global(.rui-Button-content) {\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    line-height: 20px;\n\n    @media (--desktop) {\n      width: 15px;\n      height: 15px;\n      line-height: 15px;\n    }\n  }\n}\n\n.item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-top: 15px;\n\n  @media (--desktop) {\n    align-items: center;\n  }\n\n  &:first-of-type {\n    @media (--desktop) {\n      margin-top: 25px;\n    }\n  }\n\n  & .dot {\n    width: 5px;\n    height: 5px;\n    margin-top: 8px;\n    border-radius: 50%;\n    background-color: #343b4c;\n  }\n\n  & p {\n    font-family: Roboto, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n    width: calc(100% - 5px - 10px);\n    margin: 0 0 0 10px;\n\n    @media (--desktop) {\n      width: 430px;\n      margin: 0 0 0 20px;\n    }\n\n    & a,\n    & span {\n      cursor: pointer;\n      color: #315efb;\n\n      &:hover,\n      &:focus,\n      &:active {\n        color: #6674a6;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `src-containers-Profile-Suggestions-styles--banner--AIura`,
	"expanded": `src-containers-Profile-Suggestions-styles--expanded--B8nZ7`,
	"button": `src-containers-Profile-Suggestions-styles--button--Nza5d`,
	"item": `src-containers-Profile-Suggestions-styles--item--xT8l8`,
	"dot": `src-containers-Profile-Suggestions-styles--dot--cXBcA`
};
module.exports = ___CSS_LOADER_EXPORT___;
